export const isTrue = <T>(value: T): value is NonNullable<T> => {
  return Boolean(value);
};
